'use strict';
import {runInjector} from '../../_libs/angular-utils/index';
import {PopoverSelectTemplateService} from './PopoverSelectTemplateService';
import {SelectOptionsService} from './SelectOptionsFactory';
import {PopoverSelectDirective} from './PopoverSelectDirective';
import {PopoverSelectContainerDirective} from './PopoverSelectContainerDirective';
import {PopoverSelectComponent} from './PopoverSelectComponent';
import {PopoverSelectController} from './PopoverSelectController';
const angular = require('angular');

module.exports = angular
  .module('app.components.popover-select', [])
  .constant('PopoverSelectComponent', PopoverSelectComponent)
  .run(runInjector(PopoverSelectComponent))
  .service('popoverSelectTemplateService', PopoverSelectTemplateService)
  .service('$selectOptions', SelectOptionsService)
  .directive('popoverSelect', PopoverSelectDirective)
  .directive('popoverSelectContainer', PopoverSelectContainerDirective)
  .controller('PopoverSelectController', PopoverSelectController)
;



// WEBPACK FOOTER //
// ./src/js/core-components/popover-select/index.js